import { render, staticRenderFns } from "./add-undershirts.vue?vue&type=template&id=6a1aba26&"
import script from "./add-undershirts.vue?vue&type=script&lang=js&"
export * from "./add-undershirts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports